import type { Loader } from '@googlemaps/js-api-loader'
import type { ShallowRef } from 'vue'

export const ProductInjection: InjectionKey<{
  product: ComputedRef<Product>,
  mainId: Ref<string>
}> = Symbol('product')

export const DialogInjection: InjectionKey<{
  close: () => void
}> = Symbol('dialog')

export const DisclosureInjection: InjectionKey<{
  isOpen: ComputedRef<boolean>,
  toggle: () => void,
  expand: () => void,
  close: () => void
}> = Symbol('disclosure')

export const DisclosureGroupInjection: InjectionKey<{
  toggleState: (state: Ref<boolean>) => void,
  setState: (state: Ref<boolean>, value: boolean) => void,
  init: (state: Ref<boolean>) => void,
  destroy: (state: Ref<boolean>) => void,
  outsideClose: boolean
}> = Symbol('disclosure-group')

export const GoogleMapsInjection: InjectionKey<{
  loader: Loader,
  google: ShallowRef<typeof globalThis.google | null>,
  map: ShallowRef<google.maps.Map | null>
}> = Symbol('google-maps')

export const GoogleMapsMarkerInjection: InjectionKey<{
  marker: ShallowRef<google.maps.marker.AdvancedMarkerElement | null>
}> = Symbol('google-maps-marker')